module.exports = __webpack_public_path__ + "static/media/triangle.825d368b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/triangle.svg
// module id = 228
// module chunks = 0